import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SaleCheckoutButtonsComponent } from './sale-checkout-buttons.component';
import { FormsModule } from '@angular/forms';
import { SalePaymentStripeComponentModule } from 'src/app/sales/sale-checkout/sale-payment-stripe/sale-payment-stripe.module';
import { SaleRefundPickerComponentModule } from '../sale-refund-picker/sale-refund-picker.module';
import { SaleRefundCardConfirmationComponentModule } from '../sale-refund-card-confirmation/sale-refund-card-confirmation.module';  
import { SaleRefundInteracComponentModule } from '../sale-refund-interac/sale-refund-interac.module';
import { SharedModule } from '../../../../shared.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    SalePaymentStripeComponentModule,
    SaleRefundPickerComponentModule,
    SaleRefundCardConfirmationComponentModule,
    SaleRefundInteracComponentModule,
    SharedModule
  ],
  declarations: [SaleCheckoutButtonsComponent],
  exports: [SaleCheckoutButtonsComponent]
})
export class SaleCheckoutButtonsComponentModule {}